import React, { useEffect } from 'react';
import ReduxToastr from 'react-redux-toastr';
import NavRoutes from './routes/Routes';
import ToastNotification from './ToastNotification';
import { useLocation } from 'react-router-dom';
import { initGA } from '../utils/initGA';
import { useSelector } from 'react-redux';

const App = () => {
  const location = useLocation();
  const authState = useSelector((state) => state.authUser);
  const user_id = authState?.profile?.user_id;
  const user_email = authState?.profile?.email;

  useEffect(() => {
    initGA(user_id, user_email);
  }, [user_id, user_email]);

  useEffect(() => {
    if (process.env.REACT_APP_IS_TRACKING_REQUIRED === 'true' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
        app_user_id: user_id,
        app_user_email: user_email
      });
    }
  }, [location]);

    return (
        <>
            <iframe src={`${process.env.REACT_APP_SHARE_POINT_URL}`} style={{ display: 'none' }} ></iframe>
            <ToastNotification />
            <ReduxToastr
                timeOut={4000}
                newestOnTop={false}
                preventDuplicates
                position="top-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar={true}
            />
            <NavRoutes />
        </>
    );
};

export default App;
